import { getLocalizedString } from "../../utils";
import React from "react";
import "react-multi-carousel/lib/styles.css";
import { ProductImage } from "../common/ProductImage";

const MiniCartItem = ({
  id,
  seasonCode = "",
  modelCode = "",
  articleCode = "",
  style,
  productId,
  orderId,
  imagedefault,
}) => {
  return (
    <ProductImage
      img={imagedefault}
      width="100px"
      height={"120px"}
      scale={"1.2"}
      removeButton={true}
      buttonFunction={() => {
        dispatchEvent(
          new CustomEvent("MINICART_DELETE", {
            bubbles: true,
            detail: {
              productId: productId,
              orderId: orderId,
              modelCode: modelCode,
              message: getLocalizedString("DELETEORDER_ITEM_MESSAGE_MINICART"),
              clearValues: true,
            },
          }),
        );
      }}
    ></ProductImage>
  );
};

export { MiniCartItem };
